<wilson-ag-grid-column-tree
  [gridUniqueId]="gridUniqueId"
  [gridApi]="gridApi"
></wilson-ag-grid-column-tree>
